export const AppConfig = {
    stripeToken:
        process.env.NODE_ENV === "production"
            ? "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe"
            : "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe",
    stripeTestToken: "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe",

};
